import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { PackagePlus } from 'lucide-react';

const URL = `${process.env.REACT_APP_BACKEND_URL}/api/pas-treasury-check/admin/stablecoin/stock-swap-wallet`;

export const StockSwapWallet = ({ token, onDone }) => {
  const [amt, setAmt] = useState('100');
  const [ref, setRef] = useState('Treasury reserve for swap inventory');
  const [jobs, setJobs] = useState([]);
  const h = { headers: { Authorization: `Bearer ${token}` } };
  const load = useCallback(() => axios.get(URL, { headers: { Authorization: `Bearer ${token}` } }).then(r => setJobs(r.data.jobs)).catch(() => {}), [token]);
  useEffect(() => { load(); }, [load]);
  const running = jobs.some(j => j.status === 'running');
  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(() => load().then(() => onDone && onDone()), 6000);
    return () => clearInterval(t);
  }, [running, load, onDone]);
  const go = async () => {
    if (!window.confirm(`Record a $${Number(amt).toLocaleString()} cash reserve and mint ${Number(amt).toLocaleString()} BETH USD to the swap wallet on Base?`)) return;
    try { const r = await axios.post(URL, { amount_usd: Number(amt), reference: ref }, h); toast.success(r.data.message); load(); }
    catch (e) { toast.error(e.response?.data?.detail?.toString() || 'Failed'); }
  };
  const last = jobs[0];
  return (
    <div className="border-t border-slate-700 pt-3 space-y-2" data-testid="stock-swap-wallet">
      <p className="text-sm text-white font-semibold flex items-center gap-2"><PackagePlus className="w-4 h-4 text-emerald-400" /> Stock swap wallet with BETH USD</p>
      <div className="flex flex-wrap gap-2">
        <input type="number" min="1" value={amt} onChange={(e) => setAmt(e.target.value)} className="w-32 px-3 py-2 bg-slate-950 border border-slate-600 rounded text-white text-sm" data-testid="stock-amount" />
        <input value={ref} onChange={(e) => setRef(e.target.value)} placeholder="Reserve reference" className="flex-1 min-w-[200px] px-3 py-2 bg-slate-950 border border-slate-600 rounded text-white text-sm" data-testid="stock-reference" />
        <button disabled={running || !(Number(amt) >= 1) || ref.length < 3} onClick={go} className="px-4 py-2 bg-emerald-600 hover:bg-emerald-500 disabled:opacity-40 text-white rounded text-sm font-semibold" data-testid="stock-submit">{running ? 'Minting…' : 'Stock swap wallet'}</button>
      </div>
      {last && (
        <p className="text-[11px] text-slate-300" data-testid="stock-last-job">Last: {Number(last.amount_usd).toLocaleString()} BETH · <b className={last.status === 'completed' ? 'text-emerald-300' : last.status === 'failed' ? 'text-red-400' : 'text-amber-300'}>{last.status}</b>
          {last.mint_tx && <a href={last.mint_tx} target="_blank" rel="noreferrer" className="ml-2 text-cyan-300 underline">mint tx</a>}{last.error && <span className="ml-2 text-red-400">{last.error}</span>}</p>
      )}
      <p className="text-[10px] text-slate-500">Records a matching cash reserve on-chain, then mints to the swap wallet. To deepen the Uniswap pool, use “Fund pool” in the BETH Market tab.</p>
    </div>
  );
};
